
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48","fill":"#816cc2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 48a23.845 23.845 0 01-16.971-7.031A23.832 23.832 0 010 24 23.832 23.832 0 017.029 7.031 23.845 23.845 0 0124 0a23.845 23.845 0 0116.971 7.031A23.839 23.839 0 0148 24a23.839 23.839 0 01-7.029 16.969A23.845 23.845 0 0124 48zM12.954 22.592a1.99 1.99 0 00-1.415.586 2.009 2.009 0 000 2.83l6.993 6.988a.881.881 0 00.073.076 1.985 1.985 0 001.42.6 1.985 1.985 0 001.1-.336 2.02 2.02 0 00.312-.256l15.556-15.555a1.985 1.985 0 00.585-1.412 1.986 1.986 0 00-.585-1.414 1.977 1.977 0 00-1.413-.588 1.976 1.976 0 00-1.412.588L20.024 28.838l-5.655-5.656a1.992 1.992 0 00-1.415-.59z","fill":"inherit"}})])
          )
        }
      }
    